import React, { FC } from 'react';
import Head from 'next/head';
import get from 'lodash/get';
import { SocialMetadataFactory } from './SocialMetadata';
import defaultMetadata from '../../helpers/metadataValues';
import { Title } from './Title';

export interface PageSpecificMetadataProps {
  canonicalUrl: string;
  metadata?: {
    description?: string;
    socialMetadataComp?: ReturnType<typeof SocialMetadataFactory>;
    title?: string;
  };
}

export const PageSpecificMetadata: FC<PageSpecificMetadataProps> = ({ canonicalUrl, metadata }) => {
  const seoTitle = get(metadata, 'title', defaultMetadata.main.title);
  const seoDescription = get(metadata, 'description', defaultMetadata.main.description);
  const SocialMetadata = get(metadata, 'socialMetadataComp', SocialMetadataFactory({}));

  return (
    <>
      <Title title={seoTitle} />
      <Head>
        <meta content={seoDescription} name="description" />
      </Head>
      <SocialMetadata canonicalUrl={canonicalUrl} seoDescription={seoDescription} seoTitle={seoTitle} />
    </>
  );
};
